import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasAnyRole, type UserRole } from '@mirsad/shared';
import { useCurrentUser } from '@/features/auth/useAuth';
import { Loading } from '@/components/ui';

/**
 * Exige une session, et si `roles` est fourni, au moins un de ces roles.
 *
 * Ce garde ne remplace pas le controle serveur : il evite d'afficher une page
 * que l'API refusera de toute facon. L'autorite reste le RolesGuard de l'API.
 */
export function ProtectedRoute({ roles, children }: { roles?: UserRole[]; children: ReactNode }) {
  const { data: utilisateur, isPending } = useCurrentUser();
  const emplacement = useLocation();

  if (isPending) return <Loading />;

  if (!utilisateur) {
    const suite = encodeURIComponent(emplacement.pathname + emplacement.search);
    return <Navigate to={`/connexion?suite=${suite}`} replace />;
  }

  if (utilisateur.mustChangePassword && emplacement.pathname !== '/changer-mot-de-passe') {
    return <Navigate to="/changer-mot-de-passe" replace />;
  }

  if (roles?.length && !hasAnyRole(utilisateur.roles, roles)) {
    return <Navigate to="/acces-refuse" replace />;
  }

  return <>{children}</>;
}
